import {createContext} from "react";

const DataContext = createContext(undefined);

export default DataContext;